import React, {useEffect, useContext, useState} from "react";
import { AppContext } from "../../App.js";
          
//Import Css
import './barraMenuDown.css';

export function BarraMenuDown() {


    //  Reset al montar el componente
    useEffect(() => {
      setPanelIsOpen(false);
      setOpenMenuSlideDv(false);

    }, []); // [] asegura que solo se ejecute una vez al montar



       const {
        
        //State Barra Menu Down 
        visible,
        setVisible,
        //Menu Mobile Slide
        panelIsOpen,
        setPanelIsOpen,
           //Panel Menu Slide Dv
        openMenuSlideDv,
        setOpenMenuSlideDv,
        valorScreenDv,
        setValorScreenDv,
    
    } = useContext(AppContext);


  return(  

    /* --------- BARRA BOTON MENU DOWN STIKY ----------- */
    <div className={`barra-menu-down ${visible ? "visible" : ""}`}>


        <button
            className="btn-menu-slide"
            onClick={() => {

                setPanelIsOpen(!panelIsOpen);
                setOpenMenuSlideDv(!openMenuSlideDv);

            } }>
            
                {panelIsOpen ? (
                    <span id="btn-open-slide-down" className="material-symbols-outlined">close</span>
                ) : (
                    <span id="btn-close-slide-down" className="material-symbols-outlined">menu</span>
                )}

        </button>


    </div>

    );

}